const state = {
  polySites: [],
  activePolygon: null,
  polygons: []
};

const mutations = {
  SET_POLY_SITES(state, polySites) {
    state.polySites = polySites || [];
  },
  ADD_POLY_SITES(state, polySites) {
    if (polySites && Array.isArray(polySites)) {
      state.polySites = [...state.polySites, ...polySites];
    }
  },
  CLEAR_POLY_SITES(state) {
    state.polySites = [];
  },
  SET_ACTIVE_POLYGON(state, polygon) {
    state.activePolygon = polygon;
  },
  ADD_POLYGON(state, polygon) {
    if (polygon) {
      state.polygons.push(polygon);
    }
  },
  REMOVE_POLYGON(state, polygonId) {
    state.polygons = state.polygons.filter(p => p.id !== polygonId);
  },
  UPDATE_POLYGON(state, { polygonId, polygon }) {
    const index = state.polygons.findIndex(p => p.id === polygonId);
    if (index !== -1) {
      state.polygons.splice(index, 1, polygon);
    }
  },
  CLEAR_ALL_POLYGONS(state) {
    state.polygons = [];
    state.activePolygon = null;
    state.polySites = [];
  }
};

const actions = {
  setPolySites({ commit }, polySites) {
    commit('SET_POLY_SITES', polySites);
  },
  addPolySites({ commit }, polySites) {
    commit('ADD_POLY_SITES', polySites);
  },
  clearPolySites({ commit }) {
    commit('CLEAR_POLY_SITES');
  },
  setActivePolygon({ commit }, polygon) {
    commit('SET_ACTIVE_POLYGON', polygon);
  },
  addPolygon({ commit }, polygon) {
    commit('ADD_POLYGON', polygon);
  },
  removePolygon({ commit }, polygonId) {
    commit('REMOVE_POLYGON', polygonId);
  },
  updatePolygon({ commit }, { polygonId, polygon }) {
    commit('UPDATE_POLYGON', { polygonId, polygon });
  },
  clearAllPolygons({ commit }) {
    commit('CLEAR_ALL_POLYGONS');
  },
  onPolygonDrawn({ commit }, { polygon, polySites }) {
    commit('ADD_POLYGON', polygon);
    commit('SET_POLY_SITES', polySites);
    commit('SET_ACTIVE_POLYGON', polygon);
  },
  onPolygonDeleted({ commit }, { polygon, polySites }) {
    if (polygon && polygon.id) {
      commit('REMOVE_POLYGON', polygon.id);
    }
    commit('SET_POLY_SITES', polySites);
  },
  onPolygonEdited({ commit }, { polygon, polySites }) {
    if (polygon && polygon.id) {
      commit('UPDATE_POLYGON', { polygonId: polygon.id, polygon });
    }
    commit('SET_POLY_SITES', polySites);
    commit('SET_ACTIVE_POLYGON', polygon);
  },
  onPolygonsCleared({ commit }) {
    commit('CLEAR_ALL_POLYGONS');
  }
};

const getters = {
  polySites: state => state.polySites,
  activePolygon: state => state.activePolygon,
  polygons: state => state.polygons,
  polySitesCount: state => state.polySites.length,
  hasPolySites: state => state.polySites.length > 0,
  hasActivePolygon: state => state.activePolygon !== null
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
